import gql from 'graphql-tag'

export default gql`
  subscription OnDeleteRequirementType($workflowId: String) {
    onDeleteRequirementType(workflowId: $workflowId) {
      id
    }
  }
`
